// Dollar mirror of functions/_shared/website-bundle.js for the admin New
// Invoice dialog (CRA cannot import from outside src/). Keep in step — a
// Workers test compares the two tables.
export const WEBSITE_BUNDLE_LINES_DOLLARS = Object.freeze([
  { description: 'Website Design & Development',  unitCostDollars: 2600 },
  { description: 'Features & Functionality',      unitCostDollars: 1800 },
  { description: 'Hosting & Security (1 year)',   unitCostDollars:  300 },
  { description: 'Testing & QA',                  unitCostDollars:  299 },
  { description: '1 Year Maintenance (included)', unitCostDollars:    0 },
]);
export const WEBSITE_BUNDLE_LIST_DOLLARS = 4999;
